/**
 * Call Tracking sidebar configuration
 */
export default {
  pathPrefix: 'call_tracking',
  items: [
    {
      label: 'Incoming Calls',
      href: '/call_tracking/incoming_calls',
      icon: 'fa-light fa-phone-arrow-down-left',
      activePath: 'jensen/incoming_calls'
    },
    {
      label: 'Phone Numbers',
      href: '/call_tracking/phone_numbers',
      icon: 'fa-light fa-phone-office',
      activePath: 'jensen/phone_numbers'
    },
    {
      label: 'Number Pools',
      href: '/call_tracking/phone_number_pools',
      icon: 'fa-light fa-layer-group',
      activePath: 'jensen/phone_number_pools',
      show: (store) => store.hasFeature('jensen_phone_number_pools')
    },
    {
      label: 'Call Tracking Widgets',
      href: '/call_tracking/call_tracking_widgets',
      icon: 'fa-light fa-browser',
      activePath: 'jensen/call_tracking_widgets',
      show: (store) => store.hasFeature('jensen_phone_number_pools')
    },
    {
      label: 'Blocklist',
      href: '/call_tracking/blocklist/edit',
      icon: 'fa-light fa-phone-slash',
      activePath: 'jensen/blocklist'
    },
    {
      label: 'Telephony Accounts',
      href: '/call_tracking/telephony_accounts',
      icon: 'fa-light fa-square-list',
      activePath: 'jensen/telephony_accounts'
    },
    {
      label: 'About',
      href: '/call_tracking/abouts',
      icon: 'fa-light fa-flag',
      activePath: 'jensen/abouts'
    }
  ]
}
